import { render, staticRenderFns } from "./CardUnblockModal.vue?vue&type=template&id=d215ad2c"
import script from "./CardUnblockModal.vue?vue&type=script&lang=js"
export * from "./CardUnblockModal.vue?vue&type=script&lang=js"
import style0 from "./CardUnblockModal.vue?vue&type=style&index=0&id=d215ad2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports